// extracted by mini-css-extract-plugin
export default {"menuBlock":"vE-z","title":"wE-z","nav":"xE-z","flexCell":"yE-z","facetLink":"zE-z"};